import { Link } from 'react-router-dom';
import { Seo } from '@/components/seo/Seo';
import { appConfig } from '@/config/app';
import { getCategorySummaries } from '@/services/newsRepository';

export function CategoriesPage() {
  const categories = getCategorySummaries();

  return (
    <section className="safe-px pb-28 pt-6">
      <Seo
        title="Categorias | El Divergente"
        description="Categorias editoriales de El Divergente."
        canonical={`${appConfig.siteUrl}/categorias`}
        keywords={['categorias', 'noticias', 'Puerto San Julián']}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Categorías | El Divergente',
          url: `${appConfig.siteUrl}/categorias`
        }}
      />
      <h1 className="text-3xl font-black">Categorías</h1>
      <p className="mt-2 text-white/62">Secciones editoriales para recorrer el feed por tema.</p>
      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/categoria/${category.slug}`}
            className="rounded bg-divergent-panel p-4 transition hover:bg-white/10"
          >
            <div className="flex items-center justify-between gap-3">
              <h2 className="font-semibold">{category.name}</h2>
              <span className="rounded bg-divergent-yellow px-2 py-1 text-xs font-black text-black">
                {category.count}
              </span>
            </div>
            <p className="mt-2 text-sm leading-5 text-white/58">{category.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
